import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { LettingFeature } from '../../model/letting-feature';
import { Observable, map } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Translation } from '../../../core/model/translation';

@Injectable()
export class LettingFeatureService extends DataService<LettingFeature> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, LettingFeature, progressBar, 'letting-feature');
  }

  getAvailableForRentalObjects(): Observable<LettingFeature[]> {
    return this.client
      .get<LettingFeature[]>(`${this.endpoint}/available-for-rental-objects`)
      .pipe(map(items => this.toModels(items)));
  }

  getUsedFeatures(rentalIds: string[]): Observable<{ usedNotIncludedFeatures: LettingFeature[]; usedIncludedFeatures: LettingFeature[] }> {
    return this.client
      .post<{ notIncludedFeatures: LettingFeature[]; includedFeatures: LettingFeature[] }>(`${this.endpoint}/get-used-features`, {
        rentalObjectIds: rentalIds,
      })
      .pipe(
        catchError(error => {
          this.notification.showError(error);
          return [];
        })
      );
  }

  getUsedFeaturesByFilter(
    filter: any,
    includedIds: string[],
    excludedIds: string[],
    affectedItemsCount: number
  ): Observable<{ usedNotIncludedFeatures: LettingFeature[]; usedIncludedFeatures: LettingFeature[] }> {
    return this.client
      .post<{ notIncludedFeatures: LettingFeature[]; includedFeatures: LettingFeature[] }>(`${this.endpoint}/get-used-features-filter`, {
        filter: this.prepareFilter(filter),
        includedIds: includedIds,
        excludedIds: excludedIds,
        affectedItemsCount: affectedItemsCount,
      })
      .pipe(
        catchError(error => {
          this.notification.showError(error);
          return [];
        })
      );
  }

  updateRentalObjectFeatures(model: {
    removedFeatures: string[];
    addedIncludedFeatures: Translation[][];
    addedNotIncludedFeatures: Translation[][];
    addedIncludedLettingFeatureIds: string[];
    addedNotIncludedLettingFeatureIds: string[];
    rentalObjectIds: string[];
  }): Observable<any> {
    return this.client.post(`${this.endpoint}/update-rental-objects`, model).pipe(
      catchError(error => {
        this.notification.showError(error);
        return [];
      })
    );
  }

  updateRentalObjectFeaturesByFilter(model: {
    removedFeatures: string[];
    addedIncludedLettingFeatureIds: string[];
    addedNotIncludedLettingFeatureIds: string[];
    filteredActionModel: {
      filter: any;
      includedIds: string[];
      excludedIds: string[];
      affectedItemsCount: number;
    };
  }): Observable<any> {
    return this.client.post(`${this.endpoint}/update-rental-objects-filter`, model).pipe(
      catchError(error => {
        this.notification.showError(error);
        return [];
      })
    );
  }
}
